<!--
  - Copyright (c) 2023-2024. Haodong JU
  -->

<template>
  <v-app>
    <router-view />
    <v-dialog
      v-model="showErrorDialog"
      max-width="600"
    >
      <v-card class="pa-6 d-flex align-center justify-center flex-column">
        <v-icon
          color="error lighten-2"
          size="64"
        >
          mdi-alert-box
        </v-icon>
        <div class="text-h4 mt-6">
          {{ errorDialogTitle }}
        </div>
        <div class="text-body-2 mt-2">
          {{ errorDialogMessage }}
        </div>
        <v-btn
          class="amber lighten-4 black--text mt-4"
          elevation="0"
          @click="showErrorDialog=false"
        >
          {{ $t('confirm') }}
        </v-btn>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="showBillDetailDialog"
      :fullscreen="$vuetify.breakpoint.mobile"
      max-width="1000px"
    >
      <v-card
        v-if="showBillDetailDialog"
        color="#f6f6f6"
        tile
      >
        <bill-detail-page
          :id="billDetailId"
          @close-dialog="showBillDetailDialog=false"
        />
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="showProductDetailDialog"
      max-width="800"
    >
      <v-card color="grey lighten-4">
        <div v-if="activeProductCode">
          <product-detail
            :code="activeProductCode"
            :saa-s-guide="SaaSGuide"
          />
        </div>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="showErrorDishDialog"
      max-width="600"
    >
      <v-card class="pa-6 d-flex align-center justify-center flex-column">
        <v-icon
          color="error lighten-2"
          size="64"
        >
          mdi-alert-box
        </v-icon>
        <div class="text-h4 mt-6">
          {{ errorDishDialogTitle }}
        </div>
        <div
          class="text-body-2 mt-2"
          style="max-height: 150px; overflow: scroll"
        >
          {{ errorDishDialogMessage }}
        </div>
        <div class="d-flex">
          <v-btn
            class="blue lighten-4 black--text mt-4 mr-6"
            elevation="0"
            @click="cancelUpdateDishList"
          >
            {{ $t('return') }}
          </v-btn>
          <v-btn
            class="amber lighten-4 black--text mt-4"
            elevation="0"
            @click="updateDishList"
          >
            {{ $t('confirm') }}
          </v-btn>
        </div>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="showProductPage"
      :fullscreen="true"
    >
      <v-card
        height="100vh"
        style="border-radius: 0 !important;"
      >
        <v-system-bar>
          <v-spacer />
          <v-icon @click="closeProductPage">
            mdi-close-circle
          </v-icon>
        </v-system-bar>
        <iframe
          v-if="showProductPage"
          :src="productPageUrl"
          height="100%"
          style="height: calc(100vh - 32px)"
          width="100%"
        />
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="showWaitPaymentDialog"
      fullscreen
    >
      <v-card
        color="amber lighten-4"
        height="100vh"
        light
        tile
      >
        <div
          class="pa-16 d-flex align-center justify-center flex-column"
          style="height: 100vh"
        >
          <v-progress-circular indeterminate />
          <div class="text-body-1 mt-10">
            {{ $t('WaitForPaymentDialog') }}
          </div>
        </div>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="showInternetErrorDialog"
      max-width="600"
    >
      <v-card class="pa-6 d-flex align-center justify-center flex-column">
        <v-icon
          color="error lighten-2"
          size="64"
        >
          mdi-alert-box
        </v-icon>
        <div class="text-h4 mt-6">
          {{ $t('LoginRequiredForUsingPlugin') }}
        </div>
        <v-btn
          class="amber lighten-4 black--text mt-4"
          elevation="0"
          @click="showInternetErrorDialog=false"
        >
          {{ $t('confirm') }}
        </v-btn>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
import BillDetailPage from '@/views/AadenPages/billAndReport/bills/historyBills/BillDetailPage.vue'
import { mapMutations, mapState } from 'vuex'
import ProductDetail from '@/views/SaaS/widget/ProductDetail.vue'
import { hillo } from 'hillo'
import { showSuccessMessage } from '@/model/utils/utils'
import IKUtils from 'innerken-js-utils'
import { Remember } from '@/model/global/GlobalSettings'

export default {
  name: 'App',
  components: {
    ProductDetail,
    BillDetailPage
  },
  data: function () {
    return {
      imgSrc: require('@/assets/icon/back.png'),
      showWaitPayment: true
    }
  },
  computed: {
    ...mapState(
      [
        'loadingType', 'productPageUrl', 'errorDialogTitle', 'errorDialogMessage', 'billDetailId',
        'activeProductCode',
        'errorDishDialogMessage', 'errorDishDialogTitle', 'errorDishList', 'errorTypeImport', 'SaaSGuide'
      ]),
    showBillDetailDialog: {
      get () {
        return this.$store.state.showBillDetailDialog
      },
      set (val) {
        if (!val) {
          this.closeBillDetail()
        }
      }
    },
    showProductDetailDialog: {
      get () {
        return this.$store.state.showProductDetailDialog
      },
      set (val) {
        if (!val) {
          this.closeProductDetail()
        }
      }
    },
    showErrorDialog: {
      get () {
        return this.$store.state.showErrorDialog
      },
      set (val) {
        if (!val) {
          this.closeErrorDialog()
        }
      }
    },
    showInternetErrorDialog: {
      get () {
        return this.$store.state.showInternetErrorDialog
      },
      set (val) {
        if (!val) {
          this.closeInternetErrorDialog()
        }
      }
    },
    showProductPage: {
      get () {
        return this.$store.state.showProductPage
      },
      set (val) {
        if (!val) {
          this.closeProductPage()
        }
      }
    },
    showErrorDishDialog: {
      get () {
        return this.$store.state.showErrorDishDialog
      },
      set (val) {
        if (!val) {
          this.closeErrorDishDialog()
        }
      }
    },
    showWaitPaymentDialog: {
      get () {
        return this.$store.state.showWaitPaymentDialog
      },
      set (val) {
      }
    }
  },
  methods: {
    gotoLogin () {
      Remember.offlineMode = false
      this.$router.push({ name: 'LoginPage' })
      location.reload()
    },
    ...mapMutations(
      [
        'closeBillDetail', 'closeErrorDialog', 'closeProductDetail', 'closeErrorDishDialog', 'closeProductPage',
        'closeInternetErrorDialog'
      ]),
    async updateDishList () {
      IKUtils.showLoading(true)
      this.closeErrorDishDialog()
      if (this.errorTypeImport === 'dish') {
        for (const item of this.errorDishList) {
          await hillo.postWithUploadFile('Dishes.php?op=update', {
            ...item,
            params: JSON.stringify(item)
          }, { showLoading: false })
        }
      } else {
        for (const item of this.errorDishList) {
          item.langs = JSON.stringify(item.langs)
          await hillo.postWithUploadFile('Category.php?op=updateAttribute', {
            ...item,
            params: JSON.stringify(item)
          }, { showLoading: false })
        }
      }
      showSuccessMessage(this.$t('ImportSuccessful'))
    },
    cancelUpdateDishList () {
      IKUtils.toast(this.$t('cancel_success'), 'info')
      this.closeErrorDishDialog()
    }
  }
}
</script>
<style>
@media (min-width: 1904px) {
  .container {
    max-width: 1185px !important;
  }
}

body {
  font-weight: 500;
  user-select: none;
}

body,
.v-application,
.v-application .text-body-1,
.v-application .text-body-2,
.v-application .text-h1,
.v-application .text-h2,
.v-application .text-h3,
.v-application .text-h4,
.v-application .text-h5,
.v-application .text-h6,
.v-application .text-subtitle-1,
.v-application .text-subtitle-2,
.v-application .text-body-1,
.v-application .text-body-2,
.v-application .text-button,
.v-application .text-caption,
.v-application .text-overline {
  font-family: "Noto Sans", "Roboto Flex", sans-serif !important;
}

th {
  font-weight: 500 !important;
  white-space: nowrap;
}

.hideMore {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
